export const environment = {
  baseUrl: 'https://stepahead.staging.intechnity.dev/api',
  mobileAppUrl: 'https://stayaheadconstruction.com/mobile-app',
  domainKey: 'domain_pk_6a192235946481948b1060cc2a60c0cc05b9184dba768170',
  production: false,
  chatwoot: {
    baseUrl: 'https://support.intechnity.com',
    inboxIdentifier: 'ZLPkWHMUBd4XN7YrdkEnDkcT',
  },
  firebase: {
    apiKey: 'AIzaSyBj9VQmHMcXNWVbbmUnkZJL6B3QchrrR_g',
    authDomain: 'steyahead-dev.firebaseapp.com',
    projectId: 'steyahead-dev',
    storageBucket: 'steyahead-dev.firebasestorage.app',
    messagingSenderId: '408528601127',
    appId: '1:408528601127:web:5c5d4c1146060f73760e02',
    measurementId: 'G-2T2VTV2HTY',
  },
};
